'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const Email = createSvgIcon(
  <path
    fillRule="evenodd"
    d="M22,7 L22,16.1666667 C22,17.3055183 21.2538118,18 20,18 L20,18 L4,18 C2.74619849,18 2,17.3055183 2,16.1666667 L2,16.1666667 L2,7 L9.5,14 C11,15.5 13,15.5 14.5,14 L14.5,14 L22,7 Z M20.8093652,6 C21.2791983,6 20.7897888,6.60038118 20.3199558,6.95522388 L20.3199558,6.95522388 L12.978814,13.641791 C12.4894046,14.119403 11.5105857,14.119403 11.0211762,13.641791 L11.0211762,13.641791 L3.68003453,6.95522388 C3.21020146,6.60038118 2.72079201,6 3.19062508,6 L3.19062508,6 Z"
  />,
  'Email'
);

export default Email;
